export type ChatDatasetOption = { id: number; name: string }

/** 光标处是否正在输入 @ 数据集名（已完成 @数据集 选择则不再弹出） */
export function findActiveMention(
  text: string,
  cursor: number,
  datasets: ChatDatasetOption[] = [],
): { start: number; query: string } | null {
  const before = text.slice(0, cursor)
  const at = before.lastIndexOf('@')
  if (at < 0) return null
  if (at > 0 && !/[\s(（【]/.test(before[at - 1]!)) return null

  const segment = before.slice(at)
  const sorted = [...datasets].sort((a, b) => b.name.length - a.name.length)
  for (const ds of sorted) {
    const token = `@${ds.name}`
    if (segment === token || segment.startsWith(`${token} `)) {
      return null
    }
  }

  const query = before.slice(at + 1)
  if (/[\n@]/.test(query)) return null
  return { start: at, query }
}

export function filterDatasetMentions(
  datasets: ChatDatasetOption[],
  query: string,
): ChatDatasetOption[] {
  const q = query.trim().toLowerCase()
  if (!q) return datasets
  return datasets.filter((d) => d.name.toLowerCase().includes(q))
}

export function applyDatasetMention(
  text: string,
  mentionStart: number,
  cursor: number,
  datasetName: string,
): { text: string; cursor: number } {
  const mention = `@${datasetName} `
  const newText = text.slice(0, mentionStart) + mention + text.slice(cursor)
  return { text: newText, cursor: mentionStart + mention.length }
}

/** 从问句中解析 @数据集，返回 API 用问句（去掉 @ 段）与 dataset_id */
export function parseDatasetMention(
  text: string,
  datasets: ChatDatasetOption[],
): { datasetId?: number; message: string } {
  const trimmed = text.trim()
  if (!trimmed || !datasets.length) return { message: trimmed }
  const sorted = [...datasets].sort((a, b) => b.name.length - a.name.length)
  for (const ds of sorted) {
    const token = `@${ds.name}`
    const idx = trimmed.indexOf(token)
    if (idx < 0) continue
    const message = (trimmed.slice(0, idx) + trimmed.slice(idx + token.length))
      .replace(/\s+/g, ' ')
      .trim()
    return { datasetId: ds.id, message }
  }
  return { message: trimmed }
}

export function detectDatasetMentionLabel(
  text: string,
  datasets: ChatDatasetOption[],
): string | null {
  const { datasetId } = parseDatasetMention(text, datasets)
  if (!datasetId) return null
  return datasets.find((d) => d.id === datasetId)?.name ?? null
}
